<template>
  <b-container fluid>
    <b-row>

      <b-col lg="7" class="mt-3">
        <img class="img-single-post" id="post-img" src="https://picsum.photos/1280/720" alt=""/>

        <h2 class="">لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.</h2>
        <p class="justify-content-center mt-5">کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و
          متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو
          در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ
          به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا
          مورد استفاده قرار گیرد. </p>
      </b-col>

      <b-col lg="5" class="mt-3">
        <div class="sidebar-box">
          <div class="row" dir="ltr">
            <div class="input-group m-3">
              <div class="input-group-prepend">
            <span class="input-group-text bg-transparent  border-0" id="search-box"><b-icon icon="search"
                                                                                            class=" d-inline col-lg-12 bg-transparent"></b-icon></span>
              </div>
              <input type="text" class="form-control border-0" aria-label="Default" aria-describedby="search-box"
                     placeholder="جستجو..." dir="rtl">
            </div>
          </div>
        </div>
        <div class="sidebar-box category-box mt-6 p-5">
          <h4 class="mb-3">دسته بندی</h4>
          <ul>
            <li><a href="#" class="text-decoration-none"><span>طراحی سایت</span>
              <span class="float-left">10</span>
            </a></li>
            <li><a href="#" class="text-decoration-none"><span>طراحی سایت</span>
              <span class="float-left">10</span>
            </a></li>
            <li><a href="#" class="text-decoration-none"><span>طراحی سایت</span>
              <span class="float-left">10</span>
            </a></li>
            <li><a href="#" class="text-decoration-none"><span>طراحی سایت</span>
              <span class="float-left">10</span>
            </a></li>
            <li><a href="#" class="text-decoration-none"><span>طراحی سایت</span>
              <span class="float-left">10</span>
            </a></li>


          </ul>

        </div>
        <div class="sidebar-box p-3">
          <h4 class="mb-3">آخرین مطالب</h4>

          <b-row v-for="articleSinglePost in 5" :key="articleSinglePost" class="p-3">
            <!--     todo fix issue: image should be same line as text on small size     -->
            <div class="col-4">
              <m-a href="#">
                <m-img alt="" src="https://picsum.photos/80/80" class="rounded img-fluid"/>
              </m-a>
            </div>
            <div class="col-8">

              <m-a href="#">
                <h5 class="mt-2">استراتژی بازارهای جهانی بانک</h5>
              </m-a>
              <p> شهریور ۱۲و ۱۴۰۰</p>
            </div>
          </b-row>
        </div>

        <div class="sidebar-box p-3">
          <h4 class="mb-3">محبوب ترین برچسب ها</h4>
          <!--  todo fix issue: text should be center from top and down      -->
          <m-bt400 class="m-2" v-for="mbt400 in 5" :key="mbt400">طراحی وب</m-bt400>

        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  name: "SinglePost1",
};
</script>
<style scoped>
.img-single-post {
  border-radius: 15px;
  width: 100%;
}

.sidebar-box {
  /*padding: 15px;*/
  border-radius: 10px;

  box-shadow: 0px 5px 25px rgba(218, 211, 211, 0.3);
  margin-bottom: 30px;
  border: 1px solid #F5F4F4;
}

.sidebar-box > form > input {
  width: 90%;
  border: none;
  background: transparent;

}

.sidebar-box ul li {
  padding-right: 25px;

  margin-bottom: 20px;

}

.sidebar-box ul li a {
  color: var(--dark);
}


</style>